function base64FileUploadConfig() {
	this.setDropText = function(text) {
		this.dropText = text;
	};

	this.$get = function() {
		return this;
	};
}

export default angular
	.module("vesl.extensions.json-schema.base64FileUpload.provider", [])
	.provider("base64FileUploadConfig", base64FileUploadConfig)
	.name;